import React, { useCallback, FC, useRef } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@abayo-luc/ckeditor5/build/ckeditor';
import '@ckeditor/ckeditor5-build-classic/build/translations/de';
import { noop } from 'lodash';
import styled from 'styled-components';
import { Form } from 'antd';

import { ckEditorConfig } from '../../constants/editorConfig';
import { formNumber } from '../../utils';

interface CkEditorProps {
  value?: string;
  onChange?: (value: string) => void;
  toolbar?: String[];
  max?: number;
  name?: string;
}

const WordCounterContainer = styled.div`
  text-align: right;
  font-weight: 400;
  position: absolute;
  bottom: -24px;
  right: 0px;
`;

const CkeditorMainWrapper = styled.div`
  position: relative;
  &.ckeditor-error-wrapper {
    .ck.ck-toolbar,
    .ck.ck-editor__editable_inline {
      border: 1px solid #ff4d4f;
    }
    .ck.ck-toolbar {
      border-bottom: none;
    }
  }
`;
export const CkEditor: FC<CkEditorProps> = ({
  value = '',
  onChange = noop,
  toolbar = ['heading', '|'],
  max,
  name,
}) => {
  const formInstance = Form.useFormInstance();
  const mainCkEditor = useRef<any>(null);
  const counterTextRef = useRef<any>(null);
  /**
   * onChangeHandler
   */
  const onChangeHandler = useCallback(
    (_event: any, editor: { getData: () => any }) => {
      const data = editor.getData();
      onChange(data);
    },
    [onChange],
  );

  return (
    <CkeditorMainWrapper ref={mainCkEditor}>
      <CKEditor
        editor={ClassicEditor}
        data={value}
        config={{
          ...ckEditorConfig,
          toolbar: [...toolbar, ...ckEditorConfig.toolbar],
          wordCount: {
            displayCharacters: true,
            displayWords: true,
            onUpdate: stats => {
              if (!max) return;
              if (max && counterTextRef.current) {
                const isError = stats.characters > max;
                counterTextRef.current.innerHTML = `<div class="${
                  isError ? 'ant-form-item-explain-error' : ''
                }">${stats.characters} / ${max}</div>`;
                mainCkEditor.current?.classList.toggle('ckeditor-error-wrapper', isError);
                if (name?.trim() && isError) {
                  formInstance.setFields([
                    {
                      name,
                      errors: [`Der Text darf ${formNumber(max)} Zeichen nicht überschreiten`],
                    },
                  ]);
                } else if (name?.trim()) {
                  formInstance.setFields([
                    {
                      name,
                      errors: [],
                    },
                  ]);
                }
              }
            },
          },
        }}
        onChange={onChangeHandler}
      />
      <WordCounterContainer
        ref={counterTextRef}
        className="ant-form-item-explain ant-form-item-explain-connected"
      />
    </CkeditorMainWrapper>
  );
};
